// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MoreActions_dropdown__2v9NZ","container":"MoreActions_container__1J_RV"};